import { render, staticRenderFns } from "./BranchModal.vue?vue&type=template&id=97fb6b94"
import script from "./BranchModal.vue?vue&type=script&lang=js"
export * from "./BranchModal.vue?vue&type=script&lang=js"
import style0 from "./BranchModal.vue?vue&type=style&index=0&id=97fb6b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports